enum QueryKey {
  USERS = "users",
  USER = "user",
  MISSIONS = "missions",
  DEPARTMENTS = "departments",
  SYNC_ACTIONS = "syncActions",
  SYNC_RUNS = "syncRuns",
}

export default QueryKey;
